import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'utils/isNil';
import { navigate } from 'gatsby';
import { WebsiteImage } from 'components/TitleDescription';
import Button from 'components/Button';
import Cards from 'components/Cards/Cards';
import Text from 'components/Text';
import CallToAction from 'components/CallToAction';
import useBreakpoint from 'utils/useBreakpoint';
import { taxonomyString } from 'utils/text';
import { chunk } from 'utils/chunk';
import { CardSectionLayout } from './styles';

const CallToActionCards = props => {
  const {
    title,
    cardType,
    bodyType,
    cardInfo,
    buttonTitle,
    buttonType,
    buttonLinkTo,
    backgroundColor,
    subHeading,
    subTitle,
    subDescription,
    subLogos,
    cols,
    hubType,
    cta,
  } = props;

  const onClick = () => {
    navigate(buttonLinkTo);
  };

  const textColor =
    backgroundColor === 'White' || backgroundColor === 'Alice Blue' ? 'var(--neutral-7)' : 'white';

  let renderCards = cardInfo;
  const tmpCol = cols === 0 ? renderCards?.length : cols;
  renderCards =
    renderCards &&
    renderCards.concat(
      Array(renderCards.length % tmpCol > 0 ? tmpCol - (renderCards.length % tmpCol) : 0).fill(null)
    );
  const cardsRow = renderCards && chunk(renderCards, tmpCol);

  return (
    <CardSectionLayout
      data-testid="ctaCards-container"
      className="st-cta-cards-section"
      backgroundColor={backgroundColor}
    >
      <div style={{ textAlign: 'center' }}>
        {title && (
          <Text data-testid="ctaCards-title" type="p" size="h2" color={textColor}>
            {title}
          </Text>
        )}
        {!isNil(subHeading) && (
          <p data-testid="ctaCards-description" className="section-description">
            {subHeading.description}
          </p>
        )}

        {cardsRow && (
          <div className="card-container" data-testid="ctaCards-card-container">
            {cardsRow.map((row, index) => (
              <div className="card-row-container" key={index}>
                {row.map((item, index1) => {
                  const renderItem = item?.node || item;
                  return (
                    <div
                      className={`card-item ${tmpCol === 4 ? 'simple-responsive' : ''}`}
                      key={`card-item${renderItem?.id}${index1}`}
                    >
                      {renderItem &&
                        (cardType === 'Image' ? (
                          <Cards
                            type={'Image'}
                            bodyType={bodyType || 'blog'}
                            coverImage={
                              renderItem?.cover ||
                              renderItem?.featuredImage ||
                              renderItem?.thumbnail
                            }
                            category={
                              renderItem.subTitle ||
                              renderItem.category ||
                              taxonomyString(renderItem.taxonomy)
                            }
                            title={renderItem.title}
                            description={
                              renderItem.description?.description || renderItem?.excerpt?.excerpt
                            }
                            ctaTitle={
                              bodyType
                                ? bodyType === 'simple'
                                  ? null
                                  : 'Learn more'
                                : renderItem.ctaText
                            }
                            ctaLink={
                              renderItem.slug && hubType
                                ? `/${hubType}/${renderItem.slug}`
                                : renderItem.ctaLink
                            }
                            author={renderItem.name}
                            percent={renderItem.stats}
                            coverBackColor={renderItem.backColor}
                            markIcon={renderItem.markIcon}
                            simpleResponsive={tmpCol === 4}
                          />
                        ) : cardType === 'Press' ? (
                          <Cards
                            bodyType={'simple'}
                            category={renderItem.postDate}
                            title={renderItem.postTitle}
                            description={renderItem.metaDescription.metaDescription}
                            ctaTitle={'Learn more'}
                            ctaLink={`/press/${renderItem.slug}`}
                          />
                        ) : (
                          <Cards
                            type={cardType}
                            coverVideo={renderItem.coverWistiaVideo}
                            description={item?.description?.description}
                            author={renderItem.name}
                            percent={renderItem.stats}
                          />
                        ))}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        )}

        {buttonTitle ? (
          <div
            className="section-cta"
            data-testid="ctaCards-cta"
            data-position="Body Card Block - CTA"
          >
            <Button
              type={buttonType}
              size="big"
              style={{
                padding: '12px 24px',
                lineHeight: '150%',
              }}
              onClick={onClick}
            >
              {buttonTitle}
            </Button>
          </div>
        ) : (
          cta && <CallToAction {...cta} />
        )}
      </div>
      {!isNil(subTitle) && (
        <div className="section-bottom">
          <Text
            data-testid="ctaCards-bottom-title"
            type="h2"
            className="section-bottom-title"
            color={textColor}
          >
            {subTitle}
          </Text>
          {subLogos && (
            <div data-testid="ctaCards-logos" className="bottom-logo-wrapper">
              {subLogos.map((img, index) => {
                return (
                  <div className="logo-content" key={index}>
                    <WebsiteImage src={img} alt={img.title} />
                  </div>
                );
              })}
            </div>
          )}
          {subDescription && (
            <Text
              data-testid="ctaCards-subdescription"
              type="p"
              className="section-bottom-description"
              color={textColor}
            >
              {subDescription?.subDescription}
            </Text>
          )}
        </div>
      )}
    </CardSectionLayout>
  );
};

CallToActionCards.propTypes = {
  title: PropTypes.string,
  subHeading: PropTypes.object,
  backgroundColor: PropTypes.string,
  buttonTitle: PropTypes.string,
  buttonType: PropTypes.string,
  buttonLinkTo: PropTypes.string,
  cardType: PropTypes.string,
  cardInfo: PropTypes.array,
  subTitle: PropTypes.string,
  statCaption: PropTypes.string,
  subDescription: PropTypes.object,
  subLogos: PropTypes.array,
  cols: PropTypes.number,
};

CallToActionCards.defaultProps = {
  cols: 0,
};

export default CallToActionCards;
